import { defineStore } from "pinia";

export const useGlobalStore = defineStore("global", {
  state: () => {
    return {
      isSidebarMinimized: false,
      isAuthenticated:
        typeof window !== "undefined" ? !!localStorage.getItem("token") : false,
    };
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized;
    },
    setAuthenticated(v: boolean) {
      this.isAuthenticated = v;
    },
  },
});
